import { useEffect } from "react";

export type VersionMismatchHandler = (
  remote: string,
  local: string | null
) => void;

export function useVersionCheck(
  onMismatch: VersionMismatchHandler,
  storageKey = "appVersion",
  url = "/assets/version.json"
): void {
  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const res = await fetch(url, { cache: "no-cache" });
        if (!res.ok) {
          throw new Error(`Failed to load version.json: ${res.status}`);
        }

        const data = (await res.json()) as { version?: string } | null;
        const remoteVersion = data?.version;

        if (cancelled || !remoteVersion) return;

        const localVersion = localStorage.getItem(storageKey);

        if (localVersion !== remoteVersion) {
          onMismatch(remoteVersion, localVersion);
          localStorage.setItem(storageKey, remoteVersion);
        }
      } catch (err) {
        console.error("Version check error:", err);
      }
    }

    check();

    return () => {
      cancelled = true;
    };
  }, [onMismatch, storageKey, url]);
}
